import React from "react";
import AdminMessages from "./admin-messages";
import { getFormatDate } from "service/format-date";

class AdminMessagesController extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            page: this.props.currentPage,
            count: this.props.showedItemsCount,
            messagesCount: this.props.count,
            messagesPage: this.props.page,
        }
        this.controlButtons = [];
    }

    componentDidMount(){
        this.props.getMessages(0, 10);
    }

    getTableHeader = (header) => {
        return  this.props.deviceType === 'mobile' ? header.filter((k,i) => [2,3,5].indexOf(i) === -1) : header.map(k=> this.props.getValue(k))
    }

    getFormatDate = (date) => {
        return getFormatDate(date, "DD.MM.YYYY HH:mm:ss")
    }

    setTableValues(data){
        let tableValues = data && data.content ? data.content : [];
        return tableValues.map( (k, i) => {
            return [i+1, k.clientName, k.phoneNumber, k.email, this.getFormatDate(k.createdAt), k.industry, k.question, k.keyword, this.props.getValue(k.requestType), ""];
        })
    }

    componentDidUpdate(){
        if(this.props.showedItemsCount !== this.state.count || this.props.currentPage !== this.state.page || this.props.count !== this.state.messagesCount || this.props.page !== this.state.messagesPage){
            if(this.props.showedItemsCount !== this.state.count || this.props.currentPage !== this.state.page){
                this.props.getMessages(this.props.currentPage, this.props.showedItemsCount);
                //this.closeRightMenu();
            }
            this.setState({
                page: this.props.currentPage,
                count: this.props.showedItemsCount,
                messagesCount: this.props.count,
                messagesPage: this.props.page,
            })
            return true;
        }
        else{
            return false;
        }
    }

    render(){
        return(
            <AdminMessages {...this.props} tableHeader={this.getTableHeader(this.props.messagesHeader)} data={this.props.messages && this.props.messages.content && this.props.messages.content.length && this.setTableValues(this.props.messages)}/>
        )
    }
}

export default AdminMessagesController;